(function() {
  'use strict';
  angular.module('claims')
  .factory('Claims',['$resource', 'teledentServiceUnavailableHandler',  function($resource, teledentServiceUnavailableHandler) {
    return $resource('claims',{},{
      find: {
        method: "POST",
        url:"/claims",
        transformResponse: teledentServiceUnavailableHandler(true)
      },
      getClaimLines: {
        method: "GET",
        url:"/claims/:claimId/claimLines",
        params:{claimId:'@claimId'},
        transformResponse: teledentServiceUnavailableHandler(true)
      },
      getClaimHeader: {
        method: "GET",
        url:"/claims/:claimId",
        params:{claimId:'@claimId'},
        transformResponse: teledentServiceUnavailableHandler(true)
      },
      getClaimPayments: {
          method: "GET",
          url:"/claims/:claimId/payments",
          params:{claimId:'@claimId'},
          transformResponse: teledentServiceUnavailableHandler(true)
        }
    });
  }]);
})();
